<div class="" *ngIf="(profileState | async).mediaAnalyze !== null"  [ngClass]="!(profileState | async).loader['audit']['mediaAnalyze'] ? 'background-loader' : ''">
  <div class="spinner" *ngIf="!(profileState | async).loader['audit']['mediaAnalyze']"></div>
  <div class="">
    <h3 class="card-header">
      Words
      <a data-tooltip="Most commonly used words in post captions. Useful for understanding tone, interests, and communication style">
        <img class="icon-info" src="./assets/images/icons/info.png" />
      </a>
    </h3>
    <div class="mt-3" *ngIf="(profileState | async).mediaAnalyze.word_rank !== undefined">
      <span class="tag" *ngFor="let word of (profileState | async).mediaAnalyze.word_rank.buckets">
        {{word.key}}
      </span>

    </div>
  </div>
</div>
